import { TextMetrics as PixiTextMetrics } from '@pixi/text';
import { Rectangle } from 'pixi.js';

export const DEFAULT_TEXT_ALPHA = 1;
export const DEFAULT_SCALE = 1;

export function isNewline(text: string): boolean {
    // isNewline is declared as private inside PIXI
    return (PixiTextMetrics as any).isNewline(text);
}

export function isBreakingSpace(char: string): boolean {
    // isBreakingSpace is declared as private inside PIXI
    return (PixiTextMetrics as any).isBreakingSpace(char);
}

export function tokenize(text: string): string[] {
    // tokenize is declared as private inside PIXI
    return (PixiTextMetrics as any).tokenize(text);
}

export function metricsContext() {
    return (PixiTextMetrics as any)._context as CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D;
}

export function getTotalBounds(elements: Rectangle[]) {
    if (elements.length === 0) {
        return Rectangle.EMPTY;
    }
    const box = elements[0].clone();
    for (let i = 1; i < elements.length; i++) {
        if (elements[i].width > 0) {
            box.enlarge(elements[i]);
        }
    }
    return box;
}
